import { getDefaultScanner, scanImageData, ZBarConfigType, ZBarScanner as Scanner, ZBarSymbolType } from "@undecaf/zbar-wasm";
import { BaseFrameScanner } from "./BaseFrameScanner";

export class ZBarScanner extends BaseFrameScanner {

    protected _scanner: Scanner;

    /**************************************/

    protected async openWorkAsync() {

        this._scanner = await getDefaultScanner();

        this._scanner.setConfig(ZBarSymbolType.ZBAR_NONE, ZBarConfigType.ZBAR_CFG_ENABLE, 1);

        this._scanner.setConfig(ZBarSymbolType.ZBAR_PDF417, ZBarConfigType.ZBAR_CFG_ENABLE, 1);
    }

    /**************************************/

    protected async scanFrameWorkAsync(image: ImageData) {

        const result = await scanImageData(image, this._scanner);

        if (result && result.length > 0)
            return {
                type: result[0].typeName,
                code: result[0].decode()
            };
    }
}

